module.exports = __webpack_public_path__ + "static/media/Aldri.8c75d110.mp3";